import { ORDER_FLOW_TYPE, ORDER_TYPE_DELIVERY } from "../../../constants";
import { ICONS } from "../../../constants/utils";

export function getStepIcons(order: any, orderType: any): string[] {
  const reverseFlowIcons: string[] = [
    ICONS.Search,
    ICONS.PackageCheck,
    ICONS.Store,
    ICONS.Bike,
  ];

  const normalFlowIcons: string[] = [
    ICONS.PackageCheck,
    ICONS.Store,
    ICONS.Bike,
    ICONS.CircleCheck,
  ];

  const nonDeliveryIcons: string[] = [
    ICONS.PackageCheck,
    ICONS.Store,
    ICONS.House,
    ICONS.CircleCheck,
  ];

  if (orderType !== ORDER_TYPE_DELIVERY) return nonDeliveryIcons;
  if (order?.orderFlowType === ORDER_FLOW_TYPE.REVERSE) return reverseFlowIcons;
  return normalFlowIcons;
}
